import { useEffect } from 'react'

import { toggleArray } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import usePaginationRule from '@hooks/usePaginationRule'

import type { UseFormPayload } from '@domain-group/react-hooks'

import type { PaginationRuleModel } from '@models/types'

type ToggleSortItemPayload = {
  entityState: Partial<PaginationRuleModel>,
  setEntityState: Function,
  sortItem: string,
}

const toggleSortItem = (params: ToggleSortItemPayload) => {
  const { entityState, setEntityState, sortItem } = params
  const { sort_items_by = [] } = entityState

  const updatedSort = toggleArray(sort_items_by, sortItem)

  setEntityState({
    sort_items_by: updatedSort,
  })
}

type SetParamsPayload = {
  value: string,
  stringParams: string[],
  setState: Function,
}

const setParams = (params: SetParamsPayload) => {
  const { value, stringParams, setState } = params
  const sortOrder = stringParams.includes(value) ? 'asc' : 'desc'

  setState({
    sortItemsType: value,
    sortOrder,
  })
}

const defaultState = {
  disabled: false,
  sortItemsType: 'ad_size',
  sortOrder: 'desc',
}

type UsePaginationRuleSortPayload = {
  paginationRule: Partial<PaginationRuleModel>,
  paginationRuleFormPayload: UseFormPayload,
}

const usePaginationRuleSort = (props: UsePaginationRuleSortPayload) => {
  const { paginationRule, paginationRuleFormPayload } = props

  const [state, setState] = useSetState(defaultState)
  const { disabled, sortItemsType, sortOrder } = state

  const {
    callbacks: paginationRuleCallbacks,
    creating,
    updating,
  } = usePaginationRule(paginationRule)

  const { entityState, setEntityState } = paginationRuleFormPayload
  const { sort_items_by } = entityState

  const stringParams = ['agency_title', 'state_name', 'street_name', 'suburb_name']

  const descEnabled = !stringParams.includes(sortItemsType)

  useEffect(() => {
    const existingItem = sort_items_by?.find((item: string) => item.includes(sortItemsType))

    if (existingItem){
      setState({ disabled: true })
      return
    }

    setState({ disabled: false })
  }, [sortItemsType, sortOrder, sort_items_by?.length])

  return (
    {
      callbacks: {
        ...paginationRuleCallbacks,
        setParams: (value: string) => setParams({ value, stringParams, setState }),
        setSortOrderState: (updatedSortOrder: string) => setState({ sortOrder: updatedSortOrder }),
        toggleSortItem: (sortItem: string) => toggleSortItem({ entityState, setEntityState, sortItem }),
      },
      creating,
      disabled,
      descEnabled,
      paginationRuleFormPayload,
      sortItemsType,
      sortOrder,
      updating,
    }
  )
}

export default usePaginationRuleSort
